import { monthShortenings } from "../consts"
import moment from 'moment-timezone'

export const getFormatedDate = (year, month, day) => {
    return `${monthShortenings[month - 1]} ${day}, ${year}`;
}
export const getFormatedTime = (hour, minute, isBeforeNoon) => {
    return `${hour % 12 || 12} : ${minute < 10 ? `0${minute}` : minute} ${isBeforeNoon ? 'AM' : 'PM'}`;
}

// todo: used moment but if it is deprecated or vulnerable on Node 24.13 rework it using date-fns
export const getFormatedDateTimeString = dateString => {
    const utcDate = moment.utc(dateString)
    const localDate = utcDate.local();

    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'days').startOf('day');

    const isToday = localDate.isSame(today, 'day');
    const isYesterday = localDate.isSame(yesterday, 'day');

    const timePart = localDate.format('h:mm A');
    const datePart = isToday ? 'today' : (isYesterday ? 'yesterday' : localDate.format('MMM Do, YYYY')); // almost the same as getFormatedDate, but better because it's would format as '1st, 26th, 2nd' etc.

    return `${datePart} at ${timePart}`;
}

export const formatTimeFromSeconds = (time, includeHours = false) => {
    return new Date(time * 1000).toISOString().substr(includeHours ? 11 : 14, includeHours ? 8 : 5);
}